import { useMemo, useState } from 'react';
import { Link as FluentLink } from '@fluentui/react-components';

import { TDocument } from '@modules/documents';
import { TERMINOLOGY } from '@shared/i18n';
import TemplateUsageTree from '@modules/documents/components/nav/TemplateUsageTree';

type TProps = {
  doc: TDocument;
};

const TemplateUsageWarning = ({ doc }: TProps) => {
  const documentCount = doc.templateUsage
    ? Object.values(doc.templateUsage).reduce((acc, docs) => acc + docs.length, 0)
    : 0;
  const [showTemplates, setShowTemplates] = useState(false);

  if (documentCount === 0) return null;

  return (
    <div>
      <div className="flex space-x-2 mb-2">
        <p className="font-bold">
          This {TERMINOLOGY.template.lower} is used by {documentCount} document{documentCount === 1 ? '' : 's'}:
        </p>
        <FluentLink onClick={() => setShowTemplates(!showTemplates)}>{showTemplates ? 'Hide' : 'Show'}</FluentLink>
      </div>
      {showTemplates && <TemplateUsageTree templateUsage={doc.templateUsage} versions={doc.versions} />}
    </div>
  );
};

export default TemplateUsageWarning;
